export const resolveMobileHeaderPageTitle = (pathname = '') => {
  const normalized = String(pathname || '').replace(/\/+$/, '') || '/';
  const rules: Array<[RegExp, string]> = [
    [/^\/admin\/workspaces\/event-operations\/dashboard$/, 'ダッシュボード'],
    [/^\/admin\/workspaces\/event-operations\/events\/register$/, 'イベント登録'],
    [/^\/admin\/workspaces\/event-operations\/events\/registration-complete$/, 'イベント登録完了'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/casting-registration$/, 'キャスティング設定'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/edit$/, 'イベント情報修正'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/casting-progress$/, '参加パート設定'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/ticket-sales\/analytics$/, '券売分析'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/ticket-sales$/, '券売状況登録'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/pl$/, 'イベント損益'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/timetable$/, 'タイムテーブル設計'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/timetables\/[^/]+$/, 'タイムテーブル表示'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/participant-artists$/, '参加アーティスト'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/stage-seating(?:\/preview)?$/, 'シーティング'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+$/, 'イベント詳細'],
    [/^\/admin\/workspaces\/event-operations\/events$/, 'イベント一覧'],
    [/^\/admin\/workspaces\/event-operations\/event-chat$/, 'イベントチャット'],
    [/^\/admin\/workspaces\/event-operations\/ticket-sales$/, 'チケット売上'],
    [/^\/admin\/workspaces\/event-operations\/event-options$/, 'オプション設定'],
    [/^\/admin\/workspaces\/event-operations\/genres$/, 'ジャンル管理'],
    [/^\/admin\/workspaces\/event-operations\/venues\/register$/, '会場登録'],
    [/^\/admin\/workspaces\/event-operations\/venues\/[^/]+$/, '会場詳細'],
    [/^\/admin\/workspaces\/event-operations\/venues$/, '会場一覧'],
    [/^\/admin\/workspaces\/task-management\/dashboard$/, 'タスク'],
    [/^\/admin\/workspaces\/task-management\/templates\/new$/, 'タスクテンプレート作成'],
    [/^\/admin\/workspaces\/task-management\/events$/, 'イベント一覧'],
    [/^\/admin\/workspaces\/task-management\/quick-tasks$/, 'クイックタスク'],
    [/^\/admin\/workspaces\/task-management\/projects\/[^/]+$/, 'タスク詳細'],
    [/^\/admin\/workspaces\/artist-management\/artists\/register$/, 'アーティスト登録'],
    [/^\/admin\/workspaces\/artist-management\/artists\/registration-complete$/, 'アーティスト登録完了'],
    [/^\/admin\/workspaces\/artist-management\/artists\/[^/]+$/, 'アーティスト詳細'],
    [/^\/admin\/workspaces\/artist-management\/artists$/, 'アーティスト一覧'],
    [/^\/admin\/workspaces\/artist-management\/groups$/, 'グループ設定'],
    [/^\/admin\/workspaces\/artist-management\/parts$/, 'パート編集'],
    [/^\/admin\/workspaces\/artist-management\/group-tags$/, 'グループタグ編集'],
    [/^\/admin\/workspaces\/communications\/artist-chat\/broadcast$/, '一斉送信'],
    [/^\/admin\/workspaces\/communications\/artist-chat$/, 'アーティストチャット'],
    [/^\/admin\/workspaces\/communications\/group-chat$/, 'グループチャット'],
    [/^\/admin\/workspaces\/casting\/offers\/new$/, 'オファー申請'],
    [/^\/admin\/workspaces\/casting\/offers\/by-hold\/[^/]+$/, 'オファー詳細'],
    [/^\/admin\/workspaces\/casting\/offers\/[^/]+$/, 'オファー詳細'],
    [/^\/admin\/workspaces\/casting\/offers$/, 'オファー履歴'],
    [/^\/admin\/workspaces\/contracts\/form(?:\/[^/]+)?$/, '本契約申請'],
    [/^\/admin\/workspaces\/contracts\/confirm$/, '本契約内容の確認'],
    [/^\/admin\/workspaces\/contracts\/success$/, '本契約送信完了'],
    [/^\/admin\/workspaces\/contracts\/history$/, '本契約履歴'],
    [/^\/admin\/workspaces\/contracts\/[^/]+\/schedule-edit$/, 'スケジュール変更'],
    [/^\/admin\/workspaces\/contracts\/[^/]+\/edit\/confirm\/personal$/, '契約内容の変更'],
    [/^\/admin\/workspaces\/contracts\/[^/]+\/edit\/confirm\/common$/, '契約内容の変更'],
    [/^\/admin\/workspaces\/contracts\/[^/]+\/edit$/, '本契約修正'],
    [/^\/admin\/workspaces\/contracts\/[^/]+$/, '本契約詳細'],
    [/^\/admin\/workspaces\/finance\/dashboard$/, '経理・集計'],
    [/^\/admin\/workspaces\/finance\/payments\/monthly$/, '請求一覧'],
    [/^\/admin\/workspaces\/finance\/payments\/invoices\/[^/]+$/, '請求書プレビュー'],
    [/^\/admin\/workspaces\/library\/music$/, '楽曲管理'],
    [/^\/admin\/workspaces\/concierge\/dashboard$/, 'コンシェルジュ'],
    [/^\/admin\/workspaces\/service-ai$/, 'Casticart AI'],
    [/^\/admin\/workspaces\/planning\/ai-planner$/, 'Casticart AI'],
    [/^\/admin\/workspaces\/event-operations\/events\/[^/]+\/surveys$/, 'アンケート'],
    [/^\/admin\/workspaces\/system\/service-ai-settings$/, 'Casticart AI設定'],
    [/^\/admin\/workspaces\/system\/contract-clause-settings$/, '条項設定'],
    [/^\/admin\/workspaces\/system\/service-ai-settings\/conversations$/, 'AI会話レビュー'],
    [/^\/admin\/workspaces\/system\/service-ai-settings\/usage-logs$/, 'AIトークン利用ログ'],
    [/^\/admin\/workspaces\/system\/announcements$/, 'お知らせ管理'],
    [/^\/admin\/workspaces\/system\/operational-emails$/, 'メール配信'],
    [/^\/admin\/workspaces\/system\/bugs$/, 'バグ管理'],
    [/^\/admin\/workspaces\/system\/account-management$/, 'アカウント管理'],
    [/^\/admin\/workspaces\/system\/policies$/, '規約管理'],
    [/^\/admin\/workspaces\/system\/mobile-release$/, 'モバイル更新管理'],
    [/^\/admin\/workspaces\/system\/mac-release$/, 'macOS更新管理'],
    [/^\/admin\/workspaces\/system\/action-logs$/, 'アクションログ'],
    [/^\/admin\/workspaces\/system\/manuals(?:\/.*)?$/, 'マニュアル'],
    [/^\/admin\/settings\/profile$/, 'プロフィール設定'],
    [/^\/admin\/settings\/change-password$/, 'パスワード変更'],
    [/^\/admin\/settings\/notifications$/, '通知設定'],
    [/^\/admin\/settings\/work-availability$/, '稼働状況設定'],
    [/^\/artist\/workspaces\/event-operations\/dashboard$/, 'ダッシュボード'],
    [/^\/artist\/workspaces\/event-operations\/events\/[^/]+\/timetables\/[^/]+$/, 'タイムテーブル表示'],
    [/^\/artist\/workspaces\/event-operations\/events\/[^/]+\/stage-seating(?:\/preview)?$/, 'シーティング'],
    [/^\/artist\/workspaces\/event-operations\/events\/[^/]+$/, 'イベント詳細'],
    [/^\/artist\/workspaces\/event-operations\/events$/, 'イベント一覧'],
    [/^\/artist\/workspaces\/event-operations\/event-chat$/, 'イベントチャット'],
    [/^\/artist\/workspaces\/event-operations\/venues\/[^/]+$/, '会場詳細'],
    [/^\/artist\/workspaces\/communications\/chat$/, 'チャット'],
    [/^\/artist\/workspaces\/casting\/offers\/[^/]+$/, 'オファー詳細'],
    [/^\/artist\/workspaces\/casting\/offers$/, 'オファー一覧'],
    [/^\/artist\/workspaces\/contracts\/dashboard$/, '本契約一覧'],
    [/^\/artist\/workspaces\/contracts\/[^/]+\/print$/, '依頼書プレビュー'],
    [/^\/artist\/workspaces\/contracts\/[^/]+$/, '本契約詳細'],
    [/^\/artist\/workspaces\/concierge\/apply$/, 'コンシェルジュ申し込み'],
    [/^\/artist\/workspaces\/concierge\/additional-info\/[^/]+$/, 'イベント情報登録'],
    [/^\/artist\/workspaces\/concierge\/dashboard$/, 'コンシェルジュ'],
    [/^\/artist\/workspaces\/finance\/rewards$/, '経理・報酬'],
    [/^\/artist\/workspaces\/finance\/invoice-maker$/, '請求書メーカー'],
    [/^\/artist\/workspaces\/support\/manuals(?:\/.*)?$/, 'マニュアル'],
    [/^\/artist\/workspaces\/support\/bug-reports$/, 'バグ報告'],
    [/^\/artist\/settings\/profile$/, 'プロフィール'],
    [/^\/artist\/settings\/email-change$/, 'メールアドレス変更'],
    [/^\/artist\/settings\/bank-info$/, '請求先情報'],
    [/^\/artist\/settings\/notifications$/, '通知設定'],
    [/^\/artist\/settings\/change-password$/, 'パスワード変更'],
    [/^\/artist\/settings\/artist-photography$/, '宣材写真'],
  ];
  const matched = rules.find(([pattern]) => pattern.test(normalized));
  if (matched) return matched[1];
  return '';
};
